import useScript from 'react-script-hook';
import mockableHook from '../../utils/mockable-hook';

export default mockableHook(useScript);
